/**
 * page-title-for-user.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& .name': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }
  }
}));


export default function PageTitleForUser(props) {
  const {
    title,
    userName,
  } = props;
  const classes = useStyles(props);

  return (
    <span className={classes.root}>
      {userName && <><span className='name'>{userName}</span>'s </>}{title}
    </span>
  );
}